import { BreadcrumbJsonLd } from 'next-seo';
import { useEffect, useState } from 'react';

import trackBreadcrumbInteraction from '@event-tracks/breadcrumb-analytics';
import { CONTEXT, ELEMENT, ROLE } from '@helpers/constants/automated-tests/context-role-element';
import { getTestId } from '@helpers/functions/get-test-id/getTestId';
import parseBreadcrumb from '@helpers/parseBreadcrumb';
import useTrackMegaMenu from '@hooks/analytics/mega-menu-analytics/mega-menu-analytics';
import { Breadcrumb, BreadcrumbProps } from '@madeiramadeirabr/breadcrumb-web';
import type { IParseBreadcrumbProps } from 'types/breadcrumb/breadcrumb.types';
import * as S from './BreadcrumbSeo.styles';
import { getBreadcrumbItems } from './utils/getBreadcrumbItems';

type TBreadcrumbsSeo = {
  pageBreadcrumb: IParseBreadcrumbProps;
  origem?: string;
  moreOffers?: boolean;
  productId?: number;
};

function BreadcrumbSeo({
  pageBreadcrumb,
  origem = null,
  moreOffers = false,
  productId,
}: TBreadcrumbsSeo): JSX.Element {
  const { crumbs, crumbsSeo } = parseBreadcrumb(pageBreadcrumb, origem, moreOffers);
  const [previousUrl, setPreviousUrl] = useState('');
  const [breadcrumbItems, setBreadcrumbItems] = useState<BreadcrumbProps['items']>([]);
  const { megaMenuLocation } = useTrackMegaMenu();

  const onBackButtonClick = () => {
    window.location.href = previousUrl;
  };

  const trackClickBreadcrumb = (item: BreadcrumbProps['items'][number]) => {
    trackBreadcrumbInteraction({
      interaction_location: megaMenuLocation(),
      interaction_type: 'click',
      interaction_value: item.label,
    });
  };

  useEffect(() => {
    setPreviousUrl(window?.document.referrer);
    setBreadcrumbItems(
      getBreadcrumbItems({
        crumbItems: crumbs.map(item => ({
          id: item.id,
          label: item.label,
          href: item.href,
          onClickItem: trackClickBreadcrumb,
        })),
        previousUrl: window?.document.referrer,
        onBackButtonClick,
        productId,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <BreadcrumbJsonLd itemListElements={crumbsSeo} />
      <S.BreadcrumbContainer
        hasItemBack={!!previousUrl}
        data-testId={getTestId(CONTEXT.GENERAL, ROLE.CONTAINER, ELEMENT.BREADCRUMB)}
      >
        <Breadcrumb items={breadcrumbItems} size="small" hasItemHome={!previousUrl} />
      </S.BreadcrumbContainer>
    </>
  );
}

export default BreadcrumbSeo;
